
import { slugRequest } from '../slugRequest';

// moss 排期位
export function getMossBannerById(id: number, isNeedPrerender?: boolean): any {
  const host = (location.host === 'localhost' && isNeedPrerender)
    ? 'https://sy.qq.com/gp'
    : 'https://tiem-cdn.qq.com';
  const conf: ApiTypes.HttpRequestConfig = {
    path: `${host}/moss/product/gp/statics/operation/${id}.json`,
    isAuth: false,
    source: 'cdnJson',
    type: 'cdnJson',
    method: 'GET',
    underlizeQuery: false,
  };

  return slugRequest(conf);
}

export function getCdnJson(path: string): any {
  const conf = {
    path,
    isAuth: false,
    source: 'cdnJson',
    type: 'cdnJson',
    method: 'GET',
    underlizeQuery: false,
  };

  return slugRequest(conf);
}

export function getInfoProviderById(id: number): any {
  const host = location.host === 'localhost'
    ? 'https://sy.qq.com/gp'
    : 'https://app.ingame.qq.com';
  const conf = {
    path: `${host}/ingamego/info-provider/gp/operations/${id}`,
    isAuth: false,
    source: 'cdnJson',
    type: 'cdnJson',
    method: 'GET',
    underlizeQuery: false,
  };

  return slugRequest(conf);
}

// 获取资料库数据
export function getZLKByName(name: string, callbackName: string): any {
  const conf = {
    url: `https://gp.qq.com/zlkdatasys/data_zlk_${name}.json`,
    isAuth: false,
    source: 'zlk',
    type: 'jsonp',
    callbackName,
    underlizeQuery: false,
  };

  return slugRequest(conf);
}


